let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3x2J6")).then(() => parcelRequire('fxLXC'));